module.exports = __webpack_public_path__ + "static/profil-056_optimized-a57446abd4f0bad07889ad4b9f7e16e2.jpg";